// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

export function registerValidSW() {
  const validServiceWorker = window && window.navigator && navigator.serviceWorker;
  if (validServiceWorker) {
    // unregister existing service workers
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        return Promise.all(
          registrations.map((registration) => {
            return registration.unregister();
          }),
        );
      })
      .then(() => {
        // register service worker
        return navigator.serviceWorker.register('/service-worker.js');
      })
      .catch((error) => {
        console.error('Service worker error:', error); // eslint-disable-line
      });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}

export default {
  registerValidSW,
  unregister,
};
